import { Extension } from '@tiptap/core';

interface ValidateDocOptions {
   doc: object;
   fallbackHandler: (err: unknown) => void;
}

export const ValidateDoc = Extension.create<ValidateDocOptions>({
   name: 'validateDoc',

   addOptions() {
      return {
         doc: {},
         fallbackHandler: () => {},
      };
   },

   onCreate() {
      try {
         const doc = this.editor.schema.nodeFromJSON(this.options.doc);
         doc.check();
      } catch (err) {
         this.options.fallbackHandler(err);
      }
   },
});
